import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}


const __default__ = {
    name: "CoreUiChatHistoryMessageTitleTooltip"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    showOperatorLogins: { type: Boolean },
    getOperatorByLogin: { type: Function }
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.message.operatorGroup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-weight-bold" }, "Отдел операторов:", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(_toDisplayString(__props.message.operatorGroup.descr), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-weight-bold" }, "Получатели сообщения:", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.recipients, (login) => {
        return (_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("div", null, [
            (__props.getOperatorByLogin(login))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(__props.getOperatorByLogin(login).fio) + " ", 1),
                  (__props.showOperatorLogins)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" (" + _toDisplayString(login) + ") ", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(login), 1)
                ], 64))
          ])
        ]))
      }), 256))
    ])
  ], 64))
}
}

})